import { Component, OnInit, Input } from '@angular/core';
import { FileUploadOptions } from '@schoolbelle/api/file';
import { mockFileList } from './mock-data';
import { FileUploadListOptions } from './file-upload-list.types';

@Component({
  selector: 'app-file-upload-list',
  templateUrl: './file-upload-list.component.html',
  styleUrls: ['./file-upload-list.component.scss']
})
export class FileUploadListComponent implements OnInit {
  @Input('list') list:Array<[File, FileUploadOptions]>= mockFileList;
  @Input('access_token') access_token:string;
  @Input() opts:FileUploadListOptions;
  showDetailItemId:string;
  constructor() {}

  ngOnInit() {
  }
  trackByIndex (index) {
    return index;
  }
  onUpload (pair:[File, FileUploadOptions], event:'success'|'failure') {
  }
}
